enum AgencyUserStatus {
	Active = 90,
	Deleted = 100 
}

export default AgencyUserStatus;